import BaseModel from './BaseModel'
import Organization from './Organization'
import UserSolution from './UserSolution'
import handleAxiosError from '../utils/handleAxiosError'

export default class User extends BaseModel {

  static entity = 'users'
  static primaryKey = 'ID'

  declare ID: number
  declare organizationID: number | null
  declare username: string
  declare firstName: string
  declare lastName: string
  declare email: string
  declare phone: string
  declare live: boolean
  declare receiveSummaryEmails: boolean
  declare platformAccess: boolean
  declare terminalAccess: boolean
  declare role: string
  declare organization: Organization
  declare userSolutions: UserSolution[]

  static fields() {

    return {

      // fields
      ID: this.number(null).nullable(),
      organizationID: this.number(null).nullable(),
      username: this.string(''),
      firstName: this.string(''),
      lastName: this.string(''),
      email: this.string(''),
      phone: this.string(''),
      live: this.boolean(false),
      receiveSummaryEmails: this.boolean(null),
      platformAccess: this.boolean(true),
      terminalAccess: this.boolean(false),
      role: this.string(''), // UserRoles

      // relationships
      organization: this.belongsTo(Organization, 'organizationID'),
      userSolutions: this.hasMany(UserSolution, 'userID'),

    }

  }

  /**
   * API methods
   */

  static fetchAll() {
    return this.api()
      .get('/users/get_all', {
        dataKey: 'users',
      })
      .catch(handleAxiosError)
  }

  static saveNew(payload: any) {
    return this.api()
      .post('/users/create', payload)
      .catch(handleAxiosError)
  }

  static saveExisting(payload: UpdateUserRequest) {
    return this.api()
      .put('/users/user/' + payload.ID, payload)
      .catch(handleAxiosError)
  }

  static destroy(userID: number) {
    return this.api()
      .delete('/users/user/' + userID, {
        delete: userID,
      })
      .catch(handleAxiosError)
  }

}

export interface UpdateUserRequest {
  ID: number // this isn't actually part of the payload expected by the BE
  firstName?: string
  lastName?: string
  email?: string
  phone?: string
  live?: boolean
  receiveSummaryEmails?: boolean
  platformAccess?: boolean
  terminalAccess?: boolean
}
